export default function RestrictedAccessIcon() {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M41.6667 62.5H33.3333C27.808 62.5 22.509 64.6949 18.6019 68.6019C14.6949 72.509 12.5 77.808 12.5 83.3333V87.5H41.875M85.3125 64.6875L64.6875 85.3125M66.6667 31.25C66.6667 36.2228 64.6912 40.9919 61.1749 44.5083C57.6586 48.0246 52.8895 50 47.9167 50C42.9439 50 38.1747 48.0246 34.6584 44.5083C31.1421 40.9919 29.1667 36.2228 29.1667 31.25C29.1667 26.2772 31.1421 21.5081 34.6584 17.9917C38.1747 14.4754 42.9439 12.5 47.9167 12.5C52.8895 12.5 57.6586 14.4754 61.1749 17.9917C64.6912 21.5081 66.6667 26.2772 66.6667 31.25ZM88.2583 88.2583C84.742 91.7747 79.9728 93.7501 75 93.7501C70.0272 93.7501 65.258 91.7747 61.7417 88.2583C58.2253 84.742 56.2499 79.9728 56.2499 75C56.2499 70.0272 58.2253 65.258 61.7417 61.7417C65.258 58.2253 70.0272 56.2499 75 56.2499C79.9728 56.2499 84.742 58.2253 88.2583 61.7417C91.7747 65.258 93.7501 70.0272 93.7501 75C93.7501 79.9728 91.7747 84.742 88.2583 88.2583Z"
        stroke="#C9BBBE"
        stroke-width="6"
        stroke-linecap="square"
      />
    </svg>
  );
}
